<template>
  <div id="natcon-individual-awards-list">
    <v-card class="main-card elevation-5">
      <v-card-title class="header-container">
        <div class="header-title">
          <h2 class="text-h4 font-weight-bold">{{ PageTitle }}</h2>
          <div class="header-bar"></div>
        </div>
        <v-spacer></v-spacer>

        <v-btn @click.prevent="refreshPageData" color="success" min-width="110" rounded elevation="2"
          class="font-weight-bold px-4 py-4 mr-3 text-capitalize action-btn">
          <v-icon left>mdi-refresh</v-icon>
          Refresh
        </v-btn>

        <v-btn v-if="LomStatisticsButtonFlag" @click.prevent="openLomDetailsPrompt = true" color="primary"
          min-width="130" rounded elevation="2" class="font-weight-bold px-4 py-4 text-capitalize action-btn">
          <v-icon left>mdi-chart-box</v-icon>
          LO Statistics
        </v-btn>
      </v-card-title>

      <v-card-text class="pb-0">
        <v-container v-if="RoleId == 2" class="filter-container">
          <v-row>
            <v-col cols="12" sm="6" lg="4" md="6">
              <h6 class="field-label">
                <span class="text-danger">* </span> Zone
              </h6>
              <v-autocomplete :reduce="(option) => option.value" :items="ZoneCodeOptions" :rules="ZoneCodeRules"
                v-model="ZoneCode" dense clearable required outlined hide-details="auto" class="rounded-lg"
                placeholder="Select Zone" />
            </v-col>

            <v-col cols="12" sm="6" lg="4" md="6">
              <h6 class="field-label">
                <span class="text-danger">* </span> LO
              </h6>
              <v-autocomplete :reduce="(option) => option.value" :items="LomCodeOptions" :rules="LomCodeRules"
                v-model="LomCode" dense clearable required outlined hide-details="auto" class="rounded-lg"
                placeholder="Select LO" />
            </v-col>
          </v-row>
        </v-container>

        <v-container class="stats-container">
          <v-row wrap>
            <v-col cols="12" sm="6" md="6" lg="3">
              <div class="stat-card-wrapper">
                <v-card class="stat-card deadline-card skeleton-card" v-if="CardLoadingFlag" min-height="210"
                  elevation="5">
                  <v-card-text class="pa-6 position-relative">
                    <div class="skeleton-icon-container">
                      <v-skeleton-loader class="mx-auto skeleton-icon" type="avatar" width="60"
                        height="60"></v-skeleton-loader>
                    </div>
                    <div class="skeleton-content">
                      <v-skeleton-loader class="mt-3 mb-4" type="text" width="100"></v-skeleton-loader>
                      <v-skeleton-loader class="mb-1" type="heading" width="160"></v-skeleton-loader>
                    </div>
                    <div class="skeleton-bg-icon">
                      <v-skeleton-loader type="avatar" width="150" height="150"></v-skeleton-loader>
                    </div>
                  </v-card-text>
                </v-card>

                <v-card v-else min-height="210" elevation="5" class="stat-card deadline-card">
                  <div class="stat-card-bg-icon">
                    <v-icon>mdi-clock-outline</v-icon>
                  </div>
                  <v-card-text class="pa-6">
                    <div class="stat-icon-container animate-pulse">
                      <v-icon class="stat-icon">mdi-clock-outline</v-icon>
                    </div>
                    <div class="stat-content">
                      <h3 class="stat-title">Deadline</h3>
                      <h2 class="stat-value">
                        {{ NatconIndividualAwardEndDate }}
                      </h2>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="3">
              <div class="stat-card-wrapper">
                <v-card class="stat-card awards-card skeleton-card" v-if="CardLoadingFlag" min-height="210"
                  elevation="5">
                  <v-card-text class="pa-6 position-relative">
                    <div class="skeleton-icon-container">
                      <v-skeleton-loader class="mx-auto skeleton-icon" type="avatar" width="60"
                        height="60"></v-skeleton-loader>
                    </div>
                    <div class="skeleton-content">
                      <v-skeleton-loader class="mt-3 mb-4" type="text" width="100"></v-skeleton-loader>
                      <v-skeleton-loader class="mb-1" type="heading" width="70"></v-skeleton-loader>
                    </div>
                    <div class="skeleton-bg-icon">
                      <v-skeleton-loader type="avatar" width="150" height="150"></v-skeleton-loader>
                    </div>
                  </v-card-text>
                </v-card>

                <v-card v-else min-height="210" elevation="5" class="stat-card awards-card">
                  <div class="stat-card-bg-icon">
                    <v-icon>mdi-trophy-award</v-icon>
                  </div>
                  <v-card-text class="pa-6">
                    <div class="stat-icon-container animate-bounce">
                      <v-icon class="stat-icon">mdi-trophy-award</v-icon>
                    </div>
                    <div class="stat-content">
                      <h3 class="stat-title">Total Awards</h3>
                      <h1 class="stat-value counter-animate">
                        {{ TotalNatconIndividualAward }}
                      </h1>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="3">
              <div class="stat-card-wrapper">
                <v-card class="stat-card applied-card skeleton-card" v-if="CardLoadingFlag" min-height="210"
                  elevation="5">
                  <v-card-text class="pa-6 position-relative">
                    <div class="skeleton-icon-container">
                      <v-skeleton-loader class="mx-auto skeleton-icon" type="avatar" width="60"
                        height="60"></v-skeleton-loader>
                    </div>
                    <div class="skeleton-content">
                      <v-skeleton-loader class="mt-3 mb-4" type="text" width="100"></v-skeleton-loader>
                      <v-skeleton-loader class="mb-1" type="heading" width="70"></v-skeleton-loader>
                    </div>
                    <div class="skeleton-bg-icon">
                      <v-skeleton-loader type="avatar" width="150" height="150"></v-skeleton-loader>
                    </div>
                  </v-card-text>
                </v-card>

                <v-card v-else min-height="210" elevation="5" class="stat-card applied-card">
                  <div class="stat-card-bg-icon">
                    <v-icon>mdi-check-circle-outline</v-icon>
                  </div>
                  <v-card-text class="pa-6">
                    <div class="stat-icon-container animate-rotate">
                      <v-icon class="stat-icon">mdi-check-circle-outline</v-icon>
                    </div>
                    <div class="stat-content">
                      <h3 class="stat-title">Total Applied</h3>
                      <h1 class="stat-value counter-animate">
                        {{ TotalApplied }}
                      </h1>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="3">
              <div class="stat-card-wrapper">
                <v-card class="stat-card partial-card skeleton-card" v-if="CardLoadingFlag" min-height="210"
                  elevation="5">
                  <v-card-text class="pa-6 position-relative">
                    <div class="skeleton-icon-container">
                      <v-skeleton-loader class="mx-auto skeleton-icon" type="avatar" width="60"
                        height="60"></v-skeleton-loader>
                    </div>
                    <div class="skeleton-content">
                      <v-skeleton-loader class="mt-3 mb-4" type="text" width="100"></v-skeleton-loader>
                      <v-skeleton-loader class="mb-1" type="heading" width="70"></v-skeleton-loader>
                    </div>
                    <div class="skeleton-bg-icon">
                      <v-skeleton-loader type="avatar" width="150" height="150"></v-skeleton-loader>
                    </div>
                  </v-card-text>
                </v-card>

                <v-card v-else min-height="210" elevation="5" class="stat-card partial-card">
                  <div class="stat-card-bg-icon">
                    <v-icon>mdi-content-save-outline</v-icon>
                  </div>
                  <v-card-text class="pa-6">
                    <div class="stat-icon-container animate-fade">
                      <v-icon class="stat-icon">mdi-content-save-outline</v-icon>
                    </div>
                    <div class="stat-content">
                      <h3 class="stat-title">Partially Saved</h3>
                      <h1 class="stat-value counter-animate">
                        {{ TotalPartiallySaved }}
                      </h1>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-container>

        <v-container class="table-container pb-10">
          <v-card class="tab-card" elevation="5">
            <v-tabs v-model="tab" align-with-title next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline" show-arrows background-color="#f8f9fa" color="primary"
              slider-color="primary" dark centered icons-and-text height="70px">
              <v-tab href="#tab-1" class="tab-header">
                <v-icon small left>mdi-trophy</v-icon>
                Group I - INDIVIDUAL AWARD
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item value="tab-1">
                <v-card flat>
                  <v-card-text>
                    <v-container v-if="StartupLoadingFlag" class="pa-6">
                      <v-skeleton-loader class="mx-auto" type="table" />
                    </v-container>

                    <v-container v-if="!StartupLoadingFlag" class="pa-0">
                      <v-card class="mx-auto" elevation="0">
                        <v-data-table :headers="[
                          {
                            text: 'Status',
                            value: 'status',
                            sortable: false,
                          },
                          {
                            text: 'Bid Award',
                            value: 'bid',
                            sortable: false,
                          },
                          {
                            text: 'Award Name',
                            value: 'name',
                            sortable: true,
                          },
                          {
                            text: 'Actions',
                            value: 'actions',
                            sortable: false,
                          },
                        ]" :items="IndividualAward" :items-per-page="10" class="awards-table" :footer-props="{
                          itemsPerPageText: 'Awards per page',
                          itemsPerPageOptions: [5, 10, 15, 20],
                        }">
                          <template v-slot:item.status="{ item }">
                            <v-chip :color="item.AwardStatusColor" dark class="font-weight-medium px-4 py-2 status-chip"
                              small>
                              {{ item.AwardStatusTxt }}
                            </v-chip>
                          </template>

                          <template v-slot:item.bid="{ item }">
                            <v-tooltip bottom v-if="
                              tableOptions1.CreateButtonFlag &&
                              item.AwardStatus == 1 &&
                              StartDateFlag &&
                              EndDateFlag
                            ">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" dark rounded small elevation="2"
                                  @click="addCriteriaDetails(item.AwardTypeId)" v-bind="attrs" v-on="on"
                                  class="font-weight-medium px-4 py-1 text-capitalize">
                                  <v-icon left small>mdi-file-plus</v-icon>
                                  Bid
                                </v-btn>
                              </template>
                              <span>Bid for this award</span>
                            </v-tooltip>

                            <v-tooltip bottom v-else-if="
                              tableOptions1.CreateButtonFlag &&
                              item.AwardStatus == 1 &&
                              (!StartDateFlag || !EndDateFlag)
                            ">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn color="grey" dark rounded small @click="deadlineAlert" v-bind="attrs" v-on="on"
                                  class="font-weight-medium px-4 py-1 text-capitalize">
                                  <v-icon left small>mdi-lock-clock</v-icon>
                                  Bid
                                </v-btn>
                              </template>
                              <span>Bidding not available at this time</span>
                            </v-tooltip>

                            <v-tooltip bottom v-if="
                              item.EditButtonFlag &&
                              item.AwardId != 0 &&
                              item.AwardStatus == 4 &&
                              StartDateFlag &&
                              EndDateFlag
                            ">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn color="amber darken-2" dark rounded small elevation="2"
                                  @click="editAlert(item, $event)" v-bind="attrs" v-on="on"
                                  class="font-weight-medium px-4 py-1 ml-2 text-capitalize">
                                  <v-icon left small>mdi-pencil</v-icon>
                                  Edit
                                </v-btn>
                              </template>
                              <span>Edit this award application</span>
                            </v-tooltip>

                            <v-tooltip bottom v-else-if="
                              item.EditButtonFlag &&
                              item.AwardId != 0 &&
                              item.AwardStatus == 4 &&
                              (!StartDateFlag || !EndDateFlag)
                            ">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn color="grey" dark rounded small @click="deadlineAlert" v-bind="attrs" v-on="on"
                                  class="font-weight-medium px-4 py-1 ml-2 text-capitalize">
                                  <v-icon left small>mdi-lock-clock</v-icon>
                                  Edit
                                </v-btn>
                              </template>
                              <span>Editing not available at this time</span>
                            </v-tooltip>
                          </template>

                          <template v-slot:item.name="{ item }">
                            <div class="font-weight-medium">
                              {{ item.AwardTypeTxt }}
                            </div>
                          </template>

                          <template v-slot:item.actions="{ item }">
                            <div class="action-buttons">
                              <v-tooltip bottom v-if="
                                item.PreviewButtonFlag && item.AwardId != 0
                              ">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn icon color="primary" @click="previewAlert(item, $event)" v-bind="attrs"
                                    v-on="on" class="mr-1" small>
                                    <v-icon>mdi-file-search</v-icon>
                                  </v-btn>
                                </template>
                                <span>Preview award details</span>
                              </v-tooltip>

                              <v-tooltip bottom v-if="
                                item.DeleteButtonFlag &&
                                item.AwardId != 0 &&
                                RoleId == 2
                              ">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn icon color="error" @click="deleteAlert(item, $event)" v-bind="attrs" v-on="on"
                                    small>
                                    <v-icon>mdi-delete</v-icon>
                                  </v-btn>
                                </template>
                                <span>Delete this award application</span>
                              </v-tooltip>
                            </div>
                          </template>

                          <template v-slot:no-data>
                            <v-alert type="info" text class="mt-3" outlined>
                              No award data available
                            </v-alert>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-container>
      </v-card-text>
    </v-card>

    <v-dialog v-model="openLomDetailsPrompt" persistent max-width="85%" content-class="rounded-dialog">
      <v-card class="rounded-lg">
        <lom-details :openLomDetailsPrompt="openLomDetailsPrompt" :LomCode="LomCode"
          @hideLomDetailsPrompt="hideLomDetailsPrompt($event)" v-if="openLomDetailsPrompt"></lom-details>
      </v-card>
    </v-dialog>

    <v-dialog v-model="previewRecordPrompt" persistent max-width="85%" content-class="rounded-dialog">
      <nat-con-individual-award-preview :previewRecordPrompt="previewRecordPrompt" :recordData="recordData"
        @hidePreviewRecordPrompt="hidePreviewRecordPrompt($event)"
        v-if="previewRecordPrompt"></nat-con-individual-award-preview>
    </v-dialog>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import NatConIndividualAwardPreview from "@/view/pages/erp/jci-award/jac-natcon/individual/JACNatConIndividualAwardPreview.vue";
import LomDetails from "@/view/pages/erp/jci-award/natcon/common/LomDetails.vue";

export default {
  mixins: [common],
  components: {
    NatConIndividualAwardPreview,
    LomDetails,
  },
  data() {
    return {
      StartupLoadingFlag: false,
      LoadingFlag: false,
      SubmitFlag: false,
      CardLoadingFlag: false,
      OverlayLoadingFlag: false,

      ProgessStart: 0,
      uploadPercentage: 0,

      NatconIndividualAwardStartDate: "",
      NatconIndividualAwardEndDate: "",
      TotalNatconIndividualAward: 0,
      TotalApplied: 0,
      TotalPartiallySaved: 0,

      StartDateFlag: false,
      EndDateFlag: false,

      AwardCategoryId: 9,
      AwardGroupId: 1,
      OrganizationTypeId: 4,

      tab: "",

      ZoneCodeRules: [(v) => !!v || "Zone is required"],
      ZoneCode: "",
      ZoneCodeOptions: [],

      LomCodeRules: [(v) => !!v || "LO is required"],
      LomCode: 0,
      LomCodeOptions: [],

      IndividualAward: [],

      rows: [],
      tableData1: [],
      tableOptions1: [],
      tableColumns1: [],

      recordData: {},
      selectedData: {},

      openLomDetailsPrompt: false,
      LomStatisticsButtonFlag: false,

      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,

      ActiveStatus: "",

      valid: true,

      RoleId: 0,
      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        var zone_name = this.$session.get("ZoneName");
        zone_name = zone_name == (null || undefined) ? 0 : zone_name;

        this.PageTitle = tr.PageTitle + " - " + zone_name;
        this.PageDescription = tr.PageDescription;
        this.FloatingButtonOptions = tr.FloatingButtonOptions;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;

        this.pageData();
      }
    },
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions");
      this.ZoneCodeOptionsLoading = false;
    },
    LomCodeOptions: function () {
      console.log("watch LomCodeOptions");
      this.LomCodeOptionsLoading = false;
    },
    ZoneCode: function () {
      console.log("watch ZoneCode");
      this.IndividualAward = [];
      this.getLomCodeOptions();
    },
    LomCode: function () {
      console.log("watch LomCode");
      this.getAwardTypeDetails();
      this.getTotalNatConIndividualAwardsDetails();
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "jac_national_individual_award",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      if (this.RoleId == 2) {
        this.getZoneCodeOptions();
      }
      this.getAwardTypeDetails();
      this.getTotalNatConIndividualAwardsDetails();
    },
    getTotalNatConIndividualAwardsDetails() {
      console.log("getTotalNatConIndividualAwardsDetails called");

      var validate1 = true;
      console.log({ validate1 });

      if (validate1) {
        this.CardLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/award-type/total-awards";

        if (this.RoleId == 2) {
          // For Admin
          var upload = {
            UserInterface: 1,
            OrganizationType: this.OrganizationTypeId,
            AwardCategory: this.AwardCategoryId,
            AwardGroup: this.AwardGroupId,
            Lom: this.LomCode,
          };
        } else {
          // For Others
          var upload = {
            UserInterface: 1,
            OrganizationType: this.OrganizationTypeId,
            AwardCategory: this.AwardCategoryId,
            AwardGroup: this.AwardGroupId,
          };
        }

        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.CardLoadingFlag = false;

            flag = response.data.flag;
            output = response.data.output;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              console.log("records = " + JSON.stringify(records));
              thisIns.rows = records;

              thisIns.NatconIndividualAwardStartDate = records.StartDateTxt;
              thisIns.NatconIndividualAwardEndDate = records.EndDateTxt;
              thisIns.TotalNatconIndividualAward = records.TotalAward;
              thisIns.TotalApplied = records.TotalApplied;
              thisIns.TotalPartiallySaved = records.TotalPartiallySaved;
              thisIns.StartDateFlag = records.StartDateFlag;
              thisIns.EndDateFlag = records.EndDateFlag;
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            thisIns.CardLoadingFlag = false;
            console.log("error=" + error);
            thisIns.toast("error", error);
          });
      } else {
        var message = "";
        console.log("error=" + message);
      }
    },
    deadlineAlert() {
      console.log("deadlineAlert called");
      var htmlTxt = "";
      htmlTxt += "<h3> Natcon LO Awards Bidding will be";
      htmlTxt +=
        "<br/> Start <b> " + this.NatconIndividualAwardStartDate + " </b> and";
      htmlTxt +=
        "<br/> End <b> " + this.NatconIndividualAwardEndDate + " </b> </h3>";

      Swal.fire({
        title: "Sorry !",
        text: "",
        icon: "warning",
        html: htmlTxt,
      });
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      var selectbox1_source = "ZoneCode";
      var selectbox1_destination = "ZoneCodeOptions";
      var selectbox1_url = "api/year-wise-lom/zone-options";
      var selectbox1_conditions_array = {
        UserInterface: 4,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      var ZoneCode = this.ZoneCode;
      console.log({ ZoneCode });
      if (ZoneCode != "") {
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          ZoneCode: ZoneCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        message += "Zone should not be empty. ";
      }
    },
    addCriteriaDetails(id) {
      console.log("addCriteriaDetails called");
      console.log({ id });
      if (id > 0) {
        this.$router.push("/jac/national/individual-award/create?id=" + id);
      }
    },
    reset() {
      console.log("reset called");
      this.$refs.form.reset();
      this.AllMempership = [];
      this.AllTitles = [];
      this.AllProgramme = [];
      this.AllIncome = [];
      this.AllExpenses = [];
      this.AllProject = [];
    },
    resetMessageTxt() {
      console.log("resetMessageTxt called");
      this.ErrorMessageTxt = 0;
      this.ErrorMessageTxtFlag = "";
      this.SuccessMessageTxtFlag = 0;
      this.SuccessMessageTxt = "";
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form.resetValidation();
    },
    getAwardTypeDetails() {
      console.log("getAwardTypeDetails called");

      var validate1 = true;
      console.log({ validate1 });

      if (validate1) {
        this.SubmitFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/award-type/lists";
        if (this.RoleId == 2) {
          var upload = {
            UserInterface: 9,
            AwardCategory: this.AwardCategoryId,
            AwardGroup: this.AwardGroupId,
            Lom: this.LomCode,
          };
        } else {
          var upload = {
            UserInterface: 9,
            AwardCategory: this.AwardCategoryId,
            AwardGroup: this.AwardGroupId,
          };
        }
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        this.IndividualAward = [];

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.StartupLoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.StartupLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            var options = records.TableOptions;
            thisIns.tableOptions1 = options;

            if (flag == 1) {
              thisIns.SubmitFlag = false;
              console.log({ records });
              //   thisIns.tableColumns1 = records.TableHeader;

              thisIns.IndividualAward = records.TableData;

              thisIns.toast("success", output);
            } else {
              thisIns.SubmitFlag = false;
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            thisIns.SubmitFlag = false;
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.StartupLoadingFlag = false;
          });
      } else {
        var message = "";
        console.log("error=" + message);
      }
    },
    previewAlert(tr) {
      console.log("previewAlert called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.recordData = tr;
        this.previewRecordPrompt = true;
      } else {
        var message = "Kindly select one record to preview";
        this.errorMessage(message);
      }
    },
    hidePreviewRecordPrompt() {
      console.log("hidePreviewRecordPrompt called");
      this.previewRecordPrompt = false;
    },

    hideLomDetailsPrompt() {
      console.log("hideLomDetailsPrompt called");
      this.openLomDetailsPrompt = false;
    },
    editAlert(tr) {
      console.log("editAlert called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        var id = tr.AwardId;
        console.log({ id });
        if (id > 0) {
          this.$router.push("/jac/national/individual-award/edit?id=" + id);
        }
      } else {
        var message = "Kindly select one record to preview";
        this.errorMessage(message);
      }
    },
    hideEditRecordPrompt() {
      console.log("hideEditRecordPrompt called");
      this.editRecordPrompt = false;
    },
    deleteAlert(tr) {
      console.log("deleteAlert called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        this.selectedData = tr;
        var id = tr.AwardId;
        console.log({ id });
        if (id > 0) {
          this.confirmAlert();
        }
      } else {
        var message = "Kindly select one record to edit";
        this.errorMessage(message);
      }
    },
    confirmAlert() {
      console.log("confirmAlert called");
      var tr = this.selectedData;
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        var htmlTxt = "";
        htmlTxt += "<br/>Award Group <b> " + tr.AwardGroupDisplayText + "</b>";
        htmlTxt += "<br/> Award Name <b> " + tr.AwardTypeTitle + "</b>";
        htmlTxt += "<br/>Award Status <b> " + tr.AwardStatusTxt + "</b>";
        htmlTxt += "<br/><br/>Do you want to delete the data?";

        Swal.fire({
          title: "Are you sure?",
          text: "Do you want to delete the data?",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: `Delete`,
          confirmButtonColor: "#d33",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteRecord(tr);
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        var message = "Kindly select one record to delete";
        this.sweetAlert("error", message, false);
      }
    },
    deleteRecord(tr) {
      console.log("deleteRecord called");

      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      console.log({ tr });

      if (n1 > 0 && this.RoleId == 2) {
        this.OverlayLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/award/destroy";

        var upload = {
          UserInterface: 1,
          Award: tr.AwardId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.OverlayLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.getAwardTypeDetails();
              thisIns.sweetAlert("success", output, false);
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.OverlayLoadingFlag = false;
          });
      } else {
        console.log("some errors occured");
        var message = "Kindly select one record to delete";
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    console.log("beforeMount called");

    var RoleId = this.$session.get("RoleId");
    RoleId = RoleId == (null || undefined) ? "" : RoleId;
    console.log({ RoleId });
    this.RoleId = RoleId;

    this.refreshPageData();
  },
};
</script>
<style lang="scss">
#natcon-individual-awards-list {
  .main-card {
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 1.5rem;
    background: #ffffff;
  }

  .header-container {
    padding: 1.75rem 1.5rem;
    position: relative;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  .header-title {
    position: relative;

    h2 {
      margin-bottom: 0.25rem;
      color: #343a40;
    }

    .header-bar {
      width: 80px;
      height: 4px;
      background: #3f51b5;
      border-radius: 10px;
      margin-top: 8px;
    }
  }

  .action-btn {
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }
  }

  .filter-container {
    padding: 1.5rem 1.5rem 0.5rem;
    background: #f8f9fa;
    border-radius: 8px;
    margin-bottom: 1.5rem;

    .field-label {
      margin-bottom: 0.5rem;
      font-weight: 500;
      color: #495057;
    }
  }

  .stats-container {
    padding-bottom: 1.5rem;
  }

  .stat-card-wrapper {
    height: 100%;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-7px);
    }
  }

  .stat-card {
    border-radius: 16px;
    overflow: hidden;
    position: relative;
    height: 100%;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2) !important;

      .stat-card-bg-icon {
        opacity: 0.2;
        transform: rotate(-5deg) scale(1.1);
      }

      .stat-icon-container {
        transform: scale(1.1);
      }

      .stat-value {
        letter-spacing: 0.5px;
      }
    }

    .stat-card-bg-icon {
      position: absolute;
      bottom: -15px;
      right: -15px;
      font-size: 150px;
      opacity: 0.1;
      z-index: 0;
      line-height: 1;
      transform: rotate(-10deg);
      transition: all 0.3s ease;

      .v-icon {
        font-size: 150px;
      }
    }

    .stat-icon-container {
      position: relative;
      margin-bottom: 1rem;
      height: 60px;
      width: 60px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
      transition: all 0.3s ease;

      &.animate-pulse {
        animation: pulse 2s infinite;
      }

      &.animate-bounce {
        animation: bounce 2s ease infinite;
      }

      &.animate-rotate {
        animation: rotate 7s linear infinite;
      }

      &.animate-fade {
        animation: fade 3s ease-in-out infinite;
      }
    }

    .stat-content {
      position: relative;
      z-index: 1;
    }

    .stat-title {
      font-size: 1.2rem;
      font-weight: 600;
      color: whitesmoke;
      margin-bottom: 1rem;
      margin-top: 0.25rem;
      letter-spacing: 0.3px;
      text-transform: uppercase;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    }

    .stat-value {
      font-size: 2.5rem;
      font-weight: 700;
      color: white;
      margin-bottom: 0;
      line-height: 1.2;
      text-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;

      &.counter-animate {
        animation: countUp 2s ease-out forwards;
      }
    }
  }

  .deadline-card {
    background: linear-gradient(135deg, #3a67b1 0%, #2a518c 100%);
    color: white;

    .stat-icon-container {
      background: #0097d7;

      .stat-icon {
        color: white;
        font-size: 28px;
      }
    }
  }

  .awards-card {
    background: linear-gradient(135deg, #0097d7 0%, #0079ad 100%);
    color: white;

    .stat-icon-container {
      background: #edbe38;

      .stat-icon {
        color: white;
        font-size: 28px;
      }
    }
  }

  .applied-card {
    background: linear-gradient(135deg, #56bda3 0%, #41967f 100%);
    color: white;

    .stat-icon-container {
      background: #3a67b1;

      .stat-icon {
        color: white;
        font-size: 28px;
      }
    }
  }

  .partial-card {
    background: linear-gradient(135deg, #edbe38 0%, #c69c2e 100%);
    color: white;

    .stat-icon-container {
      background: #56bda3;

      .stat-icon {
        color: white;
        font-size: 28px;
      }
    }
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    }

    50% {
      transform: scale(1.15);
      box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2);
    }

    100% {
      transform: scale(1);
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    }
  }

  @keyframes bounce {

    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateY(0);
    }

    40% {
      transform: translateY(-12px);
    }

    60% {
      transform: translateY(-6px);
    }
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes fade {

    0%,
    100% {
      opacity: 1;
      transform: scale(1);
    }

    50% {
      opacity: 0.7;
      transform: scale(1.08);
    }
  }

  @keyframes countUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .skeleton-card {
    position: relative;
    overflow: hidden;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      animation: skeleton-shimmer 1.5s infinite;
      background: linear-gradient(90deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.15) 50%,
          rgba(255, 255, 255, 0) 100%);
    }
  }

  @keyframes skeleton-shimmer {
    0% {
      transform: translateX(-100%);
    }

    100% {
      transform: translateX(100%);
    }
  }

  @media (max-width: 960px) {
    .stat-card {
      .stat-value {
        font-size: 2.2rem;
      }
    }
  }

  @media (max-width: 600px) {
    .stat-card {
      min-height: 180px;

      .stat-value {
        font-size: 2rem;
      }
    }
  }

  .table-container {
    margin-top: 1rem;
  }

  .tab-card {
    border-radius: 12px;
    overflow: hidden;
  }

  .tab-header {
    font-weight: 500 !important;
    letter-spacing: 0.5px;
    text-transform: none !important;
    font-size: 1rem !important;
  }

  .awards-table {
    border-radius: 8px;

    .status-chip {
      font-weight: 500;
    }

    .action-buttons {
      display: flex;
      align-items: center;
    }
  }

  .rounded-dialog {
    border-radius: 12px;
    overflow: hidden;
  }
}
</style>
